<template>
  <v-chip :color="status.color" text-color="white">
    {{ status.label }}
  </v-chip>
</template>

<script>
import { EMAIL_DELIVERY_STATUS } from "@/config/EMAIL_DELIVERY_STATUS";

const STATUS_MAP = {
  [EMAIL_DELIVERY_STATUS.PENDING]: { color: "primary", label: "Pending" },
  [EMAIL_DELIVERY_STATUS.SENT]: { color: "green", label: "Sent" },
  [EMAIL_DELIVERY_STATUS.FAILED]: { color: "red", label: "Failed" },
};

export default {
  props: {
    value: { type: String, required: true },
  },
  computed: {
    status() {
      return STATUS_MAP[this.value] || STATUS_MAP[EMAIL_DELIVERY_STATUS.PENDING];
    },
  },
};
</script>
